class PatolojiRaporKurtarYenileRequest {
    hastaRaporIds: Array<number> = new Array<number>();
    revizeAciklama?: string = "";
};
export default PatolojiRaporKurtarYenileRequest;